"use client";

import { useActionState } from "react";
import { useSearchParams } from "next/navigation";

import { verifyPassphrase, type VerifyState } from "./actions";
import styles from "./page.module.css";

const initialState: VerifyState = { error: null };

export function LandmarkForm() {
  const searchParams = useSearchParams();
  const next = searchParams.get("next") ?? "/home";
  const [state, formAction, pending] = useActionState(verifyPassphrase, initialState);

  return (
    <form action={formAction} className={styles.landmarkForm}>
      <input type="hidden" name="next" value={next} />
      <label className={styles.landmarkLabel} htmlFor="passphrase">
        访问密令
      </label>
      <input
        id="passphrase"
        name="passphrase"
        type="password"
        className={`input ${styles.landmarkInput}`}
        placeholder="请输入访问密令"
        autoComplete="off"
        autoFocus
        required
      />
      {state.error ? (
        <p className={styles.landmarkError} role="alert">
          {state.error}
        </p>
      ) : null}
      <button type="submit" className={`btn btn-primary ${styles.landmarkSubmit}`} disabled={pending}>
        {pending ? "验证中…" : "进入站点"}
      </button>
    </form>
  );
}
